// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"92":"pedidopendiente","177":"home","535":"login","715":"clientes","797":"pedidomarypendiente"}[chunkId] + "." + {"92":"fd945c9d","177":"d20f32cc","535":"b724bb47","715":"3c3fc2ce","797":"55da0dd5"}[chunkId] + ".css";
};